var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
var TestModeDependentContainer = /** @class */ (function (_super) {
    __extends(TestModeDependentContainer, _super);
    function TestModeDependentContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TestModeDependentContainer.prototype.render = function () {
        return (this.childrenAreVisible() && React.createElement(React.Fragment, null, this.props.children));
    };
    TestModeDependentContainer.prototype.childrenAreVisible = function () {
        var _a = this.props, referenceMode = _a.referenceMode, playMode = _a.playMode;
        return playMode && playMode.type === referenceMode;
    };
    return TestModeDependentContainer;
}(React.Component));
export default connect(function (_a) {
    var playMode = _a.playMode;
    return ({ playMode: playMode });
})(TestModeDependentContainer);



//////////////////
// WEBPACK FOOTER
// ./src/containers/TestModeDependentContainer.tsx
// module id = 114
// module chunks = 0